/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseCategoryCardGridFragment, CategoryCardGridFragment, FullCategoryCardGridFragment} from '@amblique/contentful/app/contentful/fragments/category-card-grid';

/**
 * Get a single CategoryCardGrid by ID (base - scalars only)
 */
export const getBaseCategoryCardGridById = gql`
  ${BaseCategoryCardGridFragment}

  query GetBaseCategoryCardGridById($id: String!, $locale: String!, $preview: Boolean) {
    categoryCardGrid(id: $id, locale: $locale, preview: $preview) {
      ...BaseCategoryCardGridFragment
    }
  }
`;

/**
 * Get a single CategoryCardGrid by ID (standard - 1 level deep)
 */
export const getCategoryCardGridById = gql`
  ${CategoryCardGridFragment}

  query GetCategoryCardGridById($id: String!, $locale: String!, $preview: Boolean) {
    categoryCardGrid(id: $id, locale: $locale, preview: $preview) {
      ...CategoryCardGridFragment
    }
  }
`;

/**
 * Get a single CategoryCardGrid by ID (full - 2 levels deep)
 */
export const getFullCategoryCardGridById = gql`
  ${FullCategoryCardGridFragment}

  query GetFullCategoryCardGridById($id: String!, $locale: String!, $preview: Boolean) {
    categoryCardGrid(id: $id, locale: $locale, preview: $preview) {
      ...FullCategoryCardGridFragment
    }
  }
`;

/**
 * Get all CategoryCardGrid entries with pagination (base - scalars only)
 */
export const getBaseCategoryCardGrids = gql`
  ${BaseCategoryCardGridFragment}

  query GetBaseCategoryCardGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CategoryCardGridOrder]
    $where: CategoryCardGridFilter
    $preview: Boolean
  ) {
    categoryCardGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseCategoryCardGridFragment
      }
    }
  }
`;

/**
 * Get all CategoryCardGrid entries with pagination (standard - 1 level deep)
 */
export const getCategoryCardGrids = gql`
  ${CategoryCardGridFragment}

  query GetCategoryCardGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CategoryCardGridOrder]
    $where: CategoryCardGridFilter
    $preview: Boolean
  ) {
    categoryCardGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...CategoryCardGridFragment
      }
    }
  }
`;

/**
 * Get all CategoryCardGrid entries with pagination (full - 2 levels deep)
 */
export const getFullCategoryCardGrids = gql`
  ${FullCategoryCardGridFragment}

  query GetFullCategoryCardGrids(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [CategoryCardGridOrder]
    $where: CategoryCardGridFilter
    $preview: Boolean
  ) {
    categoryCardGridCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullCategoryCardGridFragment
      }
    }
  }
`;
